export const environment = {
  production: true,
  NG_APP_ENV: 'prod',
  version: require('../../package.json').version,
  NG_APP_IDP_URL: import.meta.env['NG_APP_IDP_URL'],
  NG_APP_BACKEND: import.meta.env['NG_APP_BACKEND'],
  NG_APP_FRONTEND: import.meta.env['NG_APP_FRONTEND'],
  NG_APP_USER_PRICES: import.meta.env['NG_APP_USER_PRICES'],
  NG_APP_MYIT_DIGITAL_ASSISTANT: import.meta.env['NG_APP_MYIT_DIGITAL_ASSISTANT'],
  NG_APP_REPORT_AN_INCIDENT: import.meta.env['NG_APP_REPORT_AN_INCIDENT'],
};
